import { createApp } from 'vue';
import App from './App.vue';
import maska from 'maska';
import vClickOutside from 'v-click-outside';
import VueApexCharts from 'vue3-apexcharts';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/scss/app.scss';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'leaflet/dist/leaflet.css';
import '@vueform/multiselect/themes/default.css';
import '@vueform/slider/themes/default.css';
import { BootstrapVueNext, BCard, BCardBody, BContainer, BCol, BFormCheckbox, BFormGroup, BDropdown, BRow, BDropdownItem, BTooltip } from 'bootstrap-vue-next';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import store from './store';

const app = createApp(App);

app.use(maska);
app.use(vClickOutside);
app.use(VueApexCharts);
app.use(BootstrapVueNext);

app.component('BCard', BCard);
app.component('BCardBody', BCardBody);
app.component('BCol', BCol);
app.component('BContainer', BContainer);
app.component('BFormCheckbox', BFormCheckbox);
app.component('BFormGroup', BFormGroup);
app.component('BDropdown', BDropdown);
app.component('BDropdownItem', BDropdownItem);
app.component('BRow', BRow);
app.directive('b-tooltip', BTooltip);
app.use(VueAwesomeSwiper)

app.use(store);
app.mount('#app');
